import React from 'react';
import './Atom.css';

function Atom({ atom }) {
  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.time) return '';
    const date = new Date(timestamp.time.seconds * 1000);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit'
    });
  };


  const getCreatorTypeIcon = (type) => {
    switch (type) {
      case 'CREATOR_HUMAN':
        return '👤';
      case 'CREATOR_AI':
        return '🤖';
      case 'CREATOR_SYSTEM':
        return '⚙️';
      default:
        return '❓';
    }
  };

  const getContent = () => {
    const textParticle = atom.particles?.find(p => p.type === 'PARTICLE_TYPE_TEXT');
    const imageParticle = atom.particles?.find(p => p.type === 'PARTICLE_TYPE_IMAGE');

    if (textParticle) {
      return {
        type: 'text',
        content: textParticle.particle.content,
        description: textParticle.particle.description
      };
    } else if (imageParticle) {
      return {
        type: 'image',
        content: imageParticle.particle.content,
        description: imageParticle.particle.description
      };
    }
    return null;
  };

  const content = getContent();
  const primaryCreator = atom.nexus.creator?.[0];

  return (
    <div className="atom-card">
      <div className="atom-header">
        <div className="atom-type-icon">
          {content?.type === 'image' ? '🖼️' : '📝'}
        </div>
        <div className="atom-title">{atom.nexus.name}</div>
        <div className="atom-timestamp">{formatTimestamp(atom.nexus.created)}</div>
      </div>

      {primaryCreator && (
        <div className="atom-creator">
          <span className="creator-icon">{getCreatorTypeIcon(primaryCreator.type)}</span>
          <span className="creator-name">{primaryCreator.name || primaryCreator.id}</span>
          {primaryCreator.description && (
            <span className="creator-description">({primaryCreator.description})</span>
          )}
        </div>
      )}

      <div className="atom-content">
        {content?.type === 'image' ? (
          <div className="atom-image">
            <img src={content.content} alt={atom.nexus.name} />
            {content.description && <p className="image-description">{content.description}</p>}
          </div>
        ) : content?.type === 'text' ? (
          <div className="atom-text">
            <p className="text-content">{content.content}</p>
            {content.description && (
              <a href={content.content} target="_blank" rel="noopener noreferrer" className="text-link">
                {content.description}
              </a>
            )}
          </div>
        ) : (
          <p className="atom-text">No content available</p>
        )}
      </div>

      <div className="atom-metadata">
        {atom.nexus.embeddings?.length > 0 && (
          <span className="embedding-badge">AI Enhanced</span>
        )}
      </div>
    </div>
  );
}

export default Atom;